import React from 'react';
import SettingsIcon from '@mui/icons-material/Settings';
import QuizIcon from '@mui/icons-material/Quiz';
import SaveIcon from '@mui/icons-material/Save';
import TuneIcon from '@mui/icons-material/Tune';
import { Avatar, Button, Card, CardContent, Container, Grid, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useT } from '../../localization/LocalizationProvider';

const cards = [
  {
    titleKey: 'Admin.Dashboard.GameSettingsTitle',
    textKey: 'Admin.Dashboard.GameSettingsText',
    to: '/admin/postavke-igre',
    icon: SettingsIcon
  },
  {
    titleKey: 'Admin.Dashboard.QuestionsTitle',
    textKey: 'Admin.Dashboard.QuestionsText',
    to: '/admin/pitanja',
    icon: QuizIcon
  },
  {
    titleKey: 'Admin.Dashboard.QuizzesTitle',
    textKey: 'Admin.Dashboard.QuizzesText',
    to: '/admin/kvizovi',
    icon: SaveIcon
  },
  {
    titleKey: 'Admin.Dashboard.GlobalSettingsTitle',
    textKey: 'Admin.Dashboard.GlobalSettingsText',
    to: '/admin/opce-postavke',
    icon: TuneIcon
  }
];

export function AdminDashboardPage() {
  const t = useT();
  return (
    <Container>
      <Stack spacing={3}>
        <Typography variant="h4">{t('Common.Dashboard')}</Typography>
        <Grid container spacing={2}>
          {cards.map((card) => {
            const Icon = card.icon;
            return (
              <Grid item xs={12} md={6} key={card.to}>
                <Card sx={{ height: '100%' }}>
                  <CardContent sx={{ height: '100%' }}>
                    <Stack spacing={2} sx={{ height: '100%' }}>
                      <Stack direction="row" spacing={2} alignItems="center">
                        <Avatar sx={{ bgcolor: 'primary.main', width: 52, height: 52 }}>
                          <Icon />
                        </Avatar>
                        <Typography variant="h6">{t(card.titleKey)}</Typography>
                      </Stack>
                      <Typography color="text.secondary" sx={{ flexGrow: 1 }}>{t(card.textKey)}</Typography>
                      <Button component={RouterLink} to={card.to} variant="contained">
                        {t('Buttons.Open')}
                      </Button>
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </Stack>
    </Container>
  );
}
